import { ReportingMelcoMachineStatisticsModelsStatisticsListFilter, ReportsApi, useAPIAction, useReportsAPI } from "melco-shared-logic";
import { useCallback } from "react";

// export const useGetReportingFilter = () => {
//   console.log("getting called");
//   const [getReportingFilter] = useAPIAction(
//     ReportsApi,
//     async (api: ReportsApi, screenName: string) => {
//       const data = await api.reportsGetUserFilter({ screenName: screenName });
//       return { successMessages: [], data };
//     },
//     {
//       translationPrefix: "",
//     }
//   );
//   return useCallback(
//     (screenName: string) => {
//       return getReportingFilter(screenName);
//     },
//     [getReportingFilter]
//   );
// };

type ReportsData = {
  reports: ReportingMelcoMachineStatisticsModelsStatisticsListFilter;
};

const initialValue = { reports: {} };

export const useGetReportingFilter = (
  screenName: string
) => {
  const handleRequest = useCallback(
    async (api: ReportsApi) => {
      const response = await api.reportsGetUserFilter({ screenName: screenName });


      const reports = response
      return {
        reports
      }
    },
    []
  );

  return useReportsAPI<ReportsData>({
    initialValue,
    handleRequest,
  });
}